import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  position: fixed;
  bottom: calc(72px + ${theme.spacing(4)}); // 72px for height of the footer
  right: 0;
  margin: 0;
  display: inline-flex;
  cursor: pointer;
  box-shadow: ${theme.shadows.floating};
  padding: ${theme.spacing(0.5, 1.5)};
  background-color: ${theme.colors.white};
  border-top-left-radius: ${theme.borderRadius.small};
  border-bottom-left-radius: ${theme.borderRadius.small};
  border: 1px solid ${theme.colors.neutral10};
  border-right: transparent;
`;

export const imageContainerStyle = css`
  @media screen and (max-width: ${breakpoints.small.max}px) {
    width: 16px;
  }
`;

export const getAnimationStyles = (shouldShow: boolean) => css`
  opacity: ${shouldShow ? 1 : 0};
  transform: translateX(${shouldShow ? 0 : 50}px);
  // visibility (delayed on hide) stops the GIF painting and drops the hidden cue from the a11y tree.
  visibility: ${shouldShow ? 'visible' : 'hidden'};
  transition: opacity 0.3s ease, transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275),
    visibility 0s linear ${shouldShow ? '0s' : '0.4s'};

  &:hover {
    transform: translateX(0) scale(1.05);
    transition: transform 0.2s ease;
  }

  &:active {
    transform: translateX(0) scale(0.95);
    transition: transform 0.1s ease;
  }

  img {
    animation: ${shouldShow ? 'float' : 'none'} 2s ease-in-out infinite;
  }

  @keyframes float {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-3px);
    }
  }
`;
